import { withNamespaces } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
    Button,
    Card,
    CardBody,
} from 'reactstrap';

import { ROUTE_PATH_ADMIN_GUARD_FREIGHTS_LIST } from 'src/modules/3rd-party-management/constants';

const QuickActions = ({
    t,
}) => {
    const history = useHistory();

    return (
        <Card className="h-100 mb-0">
            <CardBody>
                <h6 className="mb-3">{t('Quick Actions')}</h6>

                <Button block className="mb-2" color="primary" type="button">
                    <i className="ri-add-line align-middle me-1" />
                    {t('Create New Freight')}
                </Button>

                <Button
                    block
                    color="secondary"
                    onClick={() => history.push(ROUTE_PATH_ADMIN_GUARD_FREIGHTS_LIST)}
                    outline
                    type="button"
                >
                    <i className="ri-send-plane-line align-middle me-1" />
                    {t('View All Freights')}
                </Button>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(
    QuickActions
);
